import { SERVER } from 'config'

export default {
    server: SERVER
}


// WEBPACK FOOTER //
// ./src/shared/settings.js